import React from 'react'
import { ButtonOutline, FormRow } from '../../../components'
import { FormEmail } from './form-email'
import { useViewport } from '../../../utils'
import { useSelector } from 'react-redux'
import { ConfirmationPopup } from './confirmation-popup'
import auth from '../../../utils/auth'
import { ContentVerification } from './content-verification'
import { useInternationalization } from '../../../features/i18n'

const label = {
  change: {
    en: 'Change',
    id: 'Ganti'
  },
  del: {
    en: 'Delete',
    id: 'Hapus'
  },
  delete: {
    en: 'Delete Account',
    id: 'Hapus Akun'
  },
  delete_org: {
    en: 'Delete Organization',
    id: 'Hapus Organisasi'
  },
  delete_msg: {
    en: 'By deleting your account, no one will be able to see or find it.',
    id: 'Dengan menghapus akun Anda, tidak akan ada orang dapat melihat atau menemukannya.'
  },
  delete_msg_org: {
    en: 'By deleting your page, no one will be able to see or find it.',
    id: 'Dengan menghapus halaman Anda, tidak akan ada orang dapat melihat atau menemukannya.'
  }
}

const ContentEmail = ({data}) => {
  const [popedup, setPopedup] = React.useState(false)
  const [isEditing, setIsEditing] = React.useState(false)
  const { isMobile } = useViewport()
  const profile = useSelector(state => state.account.profile)
  const account = useSelector(state => state.account.data)
  const { checkIfOfficial, getAccountTypeId } = auth()
  const accountTypeId = getAccountTypeId(account)
  const isOfficial = checkIfOfficial(accountTypeId)
  const { translate, language } = useInternationalization()

  return (
    <div className="w-full">
      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'account_email_address')}
      </p>
      <FormRow>
        <p className="font-bold mb-2">{data.email}</p>
        {
          !isEditing &&
          <div style={{maxWidth: isMobile ? '100%' : '126px'}}>
            <ButtonOutline
              className="w-full"
              outlineColor="primary"
              onClick={() => setIsEditing(true)}
            >
              {label.change[language.name]}
            </ButtonOutline>
          </div>
        }
      </FormRow>
      {
        isEditing &&
        <div style={{maxWidth: '541px'}}>
          <FormEmail />
        </div>
      }

      <hr className="my-8 lg:my-16" />

      <ContentVerification />

      <hr className="my-8 lg:my-16" />

      <div className="mb-5 lg:mb-8">
        <p className="text-lg font-bold mb-5">
          {isOfficial ? label.delete_org[language.name] : label.delete[language.name]}
        </p>
        <p className="text-sm mb-5">
          {isOfficial ? label.delete_msg_org[language.name] : label.delete_msg[language.name]}
        </p>
        <p className="link text-sm" onClick={() => setPopedup(true)}>{label.del[language.name]} {profile.name}</p>
        {
          popedup &&
          <ConfirmationPopup data={profile} onClose={() => setPopedup(false)}/>
        }
      </div>
    </div>
  )
}

export { ContentEmail }
